import React, { Component } from 'react'
import slugify from 'slugify'

import Slider from '~/components/core/slider'

const Item = ({ item, smallTitle }) => {
  const keyFigure = item.fields ? item.fields : item
  const text = keyFigure.text.text ? keyFigure.text.text : keyFigure.text

  let figure = keyFigure?.title?.split(' ')
  const unit = figure?.length > 1 ? figure?.[figure.length - 1] : ''

  if (figure?.length > 1) {
    figure.pop()
  }
  figure = figure?.join(' ')

  return (
    <div className="key-figure">
      <p
        className={`key-figure__figure font-light ${smallTitle ? 'key-figure__figure--small' : ''}`}
      >
        {figure} {unit && <span>{unit}</span>}
      </p>
      <p className="key-figure__txt font-semi-bold">{text?.text ?? text}</p>
    </div>
  )
}

class SliderKeyFigures extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      hasSlider: false,
    }
  }

  componentDidMount() {
    this.controlDisplay('init')
    window.addEventListener('orientationchange', this.controlDisplay('resize'))
  }

  componentWillUnmount() {
    window.removeEventListener(
      'orientationchange',
      this.controlDisplay('resize'),
    )
  }

  controlDisplay(type) {
    let windowWidth = type === 'init' ? window.innerWidth : window.screen.width
    let hasSlider = true
    let itemsCount = this.props.data.items.length

    if (windowWidth >= 1280) {
      hasSlider = itemsCount > 3 ? true : false
    } else if (windowWidth >= 1024) {
      hasSlider = itemsCount > 2 ? true : false
    } else if (windowWidth >= 768) {
      hasSlider = itemsCount > 3 ? true : false
    }

    this.setState({ hasSlider: hasSlider })
  }

  render() {
    const flickityOptions = {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
    }

    const { data } = this.props
    const { isProject } = this.props

    const chapo = data.chapo
      ? data.chapo.chapo
        ? data.chapo.chapo
        : data.chapo
      : null

    let checkIfAllKeyFigures = true
    let smallTitle = false

    data.items.forEach((item) => {
      item = item.fields ? item.fields : item

      if (item.altImage !== undefined) {
        checkIfAllKeyFigures = false
      }

      if (item?.title?.length > 7) {
        smallTitle = true
      }
    })

    return (
      <div
        id={slugify(data.title)}
        className={`full-width-mobile overflow-hidden ${isProject ? 'full-width-tablet bg-light-blue pt-11 md:py-20' : ''}`}
      >
        <div className="row">
          <div
            className={`col-12 lg-col-6 ${isProject ? 'lg-col-offset-1' : 'lg-col-offset-2'}`}
          >
            {isProject && (
              <h2
                className={`title-block title-block--no-margin text-blue ${chapo ? 'pb-4' : 'pb-10'}`}
              >
                {data.title}
              </h2>
            )}

            {isProject && chapo && (
              <p className="paragraph mb-5 lg:mb-10">{chapo}</p>
            )}

            {checkIfAllKeyFigures ? (
              <div className="slider-key-figures">
                {this.state.hasSlider ? (
                  <Slider
                    flickityOptions={flickityOptions}
                    classes="slider-key-figures__slider"
                    navClasses="w-full text-center md:text-left mt-8"
                    iconColor="purple"
                    groupCells='{"320": 1, "768" : 3, "1024": 2, "1280": "3"}'
                  >
                    {data.items.map((item, i) => {
                      return (
                        <Item item={item} key={i} smallTitle={smallTitle} />
                      )
                    })}
                  </Slider>
                ) : (
                  <div className="flex">
                    {data.items.map((item, i) => {
                      return (
                        <Item item={item} key={i} smallTitle={smallTitle} />
                      )
                    })}
                  </div>
                )}
              </div>
            ) : (
              'Slider - Format de données incorrect. Il faut uniquement des chiffres clés si le type chiffre clés est sélectionné.'
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default SliderKeyFigures
